import _ from 'lodash';
import ScheduleReminderType from 'types/enum/ScheduleReminderType';
import { ErrorWithMessage, toErrorWithMessage } from 'utils/errorUtils';
import { getFullNameFromMember } from 'utils/stringUtils';
import { IScheduleReminderDetails, ScheduleReminder } from '../types/types';

function useSchedulingReminderPopulate() {
  async function populate(
    reminders: ScheduleReminder[],
    onError: (e: ErrorWithMessage) => void
  ): Promise<IScheduleReminderDetails[]> {
    const withPayloads = reminders.map(async (reminder) => {
      const payload = reminder.payload ? JSON.parse(reminder.payload) : undefined;
      const withPayload: IScheduleReminderDetails = { ...reminder };
      if (reminder.payload) {
        if (payload?.instructions) {
          withPayload.instructions = payload.instructions;
        }

        if (payload?.color && reminder.type !== ScheduleReminderType.BREAK) {
          withPayload.color = payload.color;
        }

        withPayload.links = _.sortBy(reminder.links, (link) => getFullNameFromMember(link.member));
        return withPayload;
      } else {
        return reminder;
      }
    });

    try {
      return Promise.all(withPayloads);
    } catch (e: unknown) {
      onError(toErrorWithMessage(e));
      return [];
    }
  }

  return populate;
}

export default useSchedulingReminderPopulate;
